const F = {
  neutral: {
    white: "#FFFFFF",
    // transmitPrimaryBtnText
    black: "#000000",
    // transmitFooterText
    50: "#F8F8F9",
    // backgroundGrey, sidePanelBackgroundGrey, expansionPanelGey, loadingOverlayColor, bannerTextWhite
    100: "#EBEBED",
    // divider, lightGray <-- NOTICE SPELLING!
    200: "#DDDDE1",
    // imageBackground, lineBreakGrey, dividerLine
    300: "#CFD0D5",
    400: "#C2C3C9",
    500: "#ADAFB7",
    // steelGrey, disabledState, lightGrey <-- NOTICE SPELLING!
    600: "#717380",
    // loadingBorderColor, lineBreak
    700: "#595A65",
    // footerGray, overlayBackground, rewardsPlatinum
    800: "#3B3C43",
    // charcoalGrey, text, vulcan, blackTransparent5, labelText, lightBlack, placeholderText
    900: "#2D2E35"
    // normalHelperText, textFlash, transmitBodyText
  },
  red: {
    50: "#FDF6F5",
    100: "#F9E5E2",
    // errorFlash, lightRed
    200: "#F6D3CF",
    300: "#F0B8B3",
    400: "#EA9E96",
    500: "#E37B70",
    600: "#D63E2E",
    // red
    700: "#C63527",
    // brick, inlineError
    800: "#6B1D15",
    900: "#4A140F"
  },
  orange: {
    50: "#FFF3E6",
    100: "#FFE0C2",
    // cdActionFlash, dashboardFlashOrange, lightOrange, pinkLady
    200: "#FFCE9D",
    300: "#FFB56B",
    400: "#FF962E",
    500: "#FC7D00",
    // autumn, cd
    600: "#D76B00",
    700: "#974B00",
    800: "#613000",
    900: "#412000"
  },
  gold: {
    50: "#FFFAE9",
    // synchronyCachedWarning
    100: "#FFEA9E",
    200: "#FFD848",
    300: "#FBC600",
    // synchronyGold
    400: "#E2B200",
    500: "#BC9500",
    // darkYellow
    600: "#977700",
    // rewardsGold
    700: "#644F00",
    800: "#3F3200",
    900: "#191400"
  },
  green: {
    50: "#EDF8EA",
    100: "#D2EFC9",
    // successFlash, lightGreen
    200: "#B7E5A9",
    300: "#93D77F",
    400: "#66C749",
    500: "#58B33D",
    600: "#3E8529",
    // green
    700: "#2B5D1D",
    800: "#1C3C12",
    900: "#13280C"
  },
  turquoise: {
    50: "#ECF5F6",
    100: "#D0E7E9",
    // lightTurquoise, nonDashboardLinkFlash
    200: "#AAD4D7",
    300: "#8EC6CA",
    400: "#69B3B9",
    500: "#4B99A0",
    // rewardsDiamond
    600: "#39757A",
    // turquoise
    700: "#306368",
    800: "#224649",
    900: "#172F31"
  },
  blue: {
    50: "#F1F9FD",
    // dashboardFlashBlue, lightSkyBlue
    100: "#D6EFFA",
    // dashboardFlash, lightBlue, dimOptimumBlue
    200: "#BCE4F8",
    300: "#9AD7F4",
    400: "#74C6EC",
    500: "#46B4E7",
    600: "#007CB7",
    700: "#006899",
    // optimumBlue, clickable, transmitBodylink
    800: "#004869",
    // darkBlue, hoverState, marineBlue
    900: "#00344D"
  },
  purple: {
    50: "#F6ECF9",
    100: "#EDD9F3",
    200: "#E4C5EC",
    300: "#D6A9E3",
    400: "#C98CDA",
    500: "#C078D4",
    600: "#AC4EC6",
    700: "#9438AE",
    800: "#84329B",
    900: "#4F1E5D"
    // barneyPurple
  }
};
export {
  F as default
};
